import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiQueryParams, ResponseObjectList } from "../../entities/global";
import { agent, encodeGetParams } from "../../api";
import { apiUrlV1 } from "../../config/config";
import { handlerNeedUpdate } from "./casesTableStore";
import { addNotification } from "../Notification/notificateStore";
import { CasesBonus, CasesEntity } from "../../entities/cases_v2";
import { FortuneWheelProfile } from "../../entities/wheelGame_v2";
import { casesUrl } from "./casesReducer";

// getCasesBonuses
export const getCasesBonuses = createAsyncThunk(
  "cases/get-bonuses-list",
  async (params?: ApiQueryParams): Promise<ResponseObjectList<CasesBonus[]>> => {
    try {
      const query = encodeGetParams({ ...params });
      const response = await agent.get(`${casesUrl}/bonus/read/list${query}`);

      if (response.ok) {
        const body = (await response.json()) as ResponseObjectList<CasesBonus[]>;

        return body;
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }

    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: [],
    };
  }
);

export const deleteCasesBonus = createAsyncThunk(
  'cases/delete-case-bonus',
  async (params: { id: number }, thunksApi) => {
    try {
      const response = await agent.delete(`${casesUrl}/bonus/delete/${params.id}`)
      if (response.ok) {
        thunksApi.dispatch(handlerNeedUpdate({ key: 'bonus', value: true }));
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)
// getCasesEntites
export const getCasesEntites = createAsyncThunk(
  'cases/get-entity-list',
  async (params?: ApiQueryParams): Promise<ResponseObjectList<CasesEntity[]>> => {
    try {
      const query = encodeGetParams({ ...params });
      const response = await agent.get(`${casesUrl}/read/list${query}`);

      if (response.ok) {
        const body = (await response.json()) as ResponseObjectList<CasesEntity[]>;

        return body;
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }

    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: [],
    };
  }
)

export const deleteCasesEntity = createAsyncThunk(
  'cases/delete-case-entity',
  async (params: { id: number }, thunksApi) => {
    try {
      const response = await agent.delete(`${casesUrl}/delete/${params.id}`)
      if (response.ok) {
        thunksApi.dispatch(handlerNeedUpdate({ key: 'entity', value: true }));
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)
// getCasesProfiles
export const getCasesProfiles = createAsyncThunk(
  'cases/get-profile-list',
  async (params?: ApiQueryParams): Promise<ResponseObjectList<FortuneWheelProfile[]>> => {
    try {
      const query = encodeGetParams({ ...params });
      const response = await agent.get(`${apiUrlV1}/v3/organization/game/profile/read/case/list${query}`);

      if (response.ok) {
        const body = (await response.json()) as ResponseObjectList<FortuneWheelProfile[]>;

        return body;
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }

    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: [],
    };
  }
)

export const deleteCasesProfile = createAsyncThunk(
  'cases/delete-case-profile',
  async (params: { id: number }, thunksApi) => {
    try {
      const response = await agent.delete(`${apiUrlV1}/v3/organization/game/profile/delete/${params.id}`)
      if (response.ok) {
        thunksApi.dispatch(handlerNeedUpdate({ key: 'profile', value: true }));
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)